import Blog from "@/Layouts/Blog";
import Contact from "@/Sections/Contact";
import { Head } from "@inertiajs/inertia-react";

export default () => {
    return (
        <Blog>
            <Head>
                <title>
                    Hoe je een feestje bouwt zonder de kater: Drie alcoholvrije
                    cocktails die je smaakpapillen laten dansen
                </title>
                <link rel="canonical" href={route("blogs.fifty-nine")} />

                <meta
                    name="viewport"
                    content="width=device-width, initial-scale=1"
                />
                <meta property="og:locale" content="nl_NL" />

                <meta
                    name="description"
                    content="Heb je ooit op een feest gestaan met een glas water in je hand, terwijl iedereen om je heen proost met de meest kleurrijke en exotische drankjes? Voelde je je als een smartphone met een lege batterij op een festival? Vrees niet, want ik kom je redden met recepten voor alcoholvrije cocktails die zo lekker zijn dat zelfs je lever je een staande ovatie zal geven."
                />
                <meta
                    property="og:description"
                    content="Heb je ooit op een feest gestaan met een glas water in je hand, terwijl iedereen om je heen proost met de meest kleurrijke en exotische drankjes? Voelde je je als een smartphone met een lege batterij op een festival? Vrees niet, want ik kom je redden met recepten voor alcoholvrije cocktails die zo lekker zijn dat zelfs je lever je een staande ovatie zal geven."
                />
                <meta property="og:url" content={route("blogs.fifty-nine")} />
                <meta property="og:type" content="article" />
                <meta
                    property="og:title"
                    content="Hoe je een feestje bouwt zonder de kater: Drie alcoholvrije cocktails die je smaakpapillen laten dansen - WE ARE Personal Training Uden en Schijndel"
                />
                <meta property="og:image" content="/assets/blog/feestje.png" />
            </Head>

            <div className="bg-black">
                <div className="relative xs:h-[30vh] sm:h-[30vh] md:h-[65vh] lg:h-[65vh] pb-32">
                    <div>
                        <div className="absolute inset-0">
                            <picture>
                                <source
                                    srcSet="/assets/blog/webp/feestje.webp"
                                    type="image/webp"
                                    alt="Feestje"
                                    className="xs:w-full sm:w-full md:w-full lg:w-full h-full object-cover"
                                />
                                <source
                                    srcSet="/assets/blog/feestje.png"
                                    type="image/jpeg"
                                    alt="Feestje"
                                    className="xs:w-full sm:w-full md:w-full lg:w-full h-full object-cover"
                                />
                                <img
                                    src="/assets/blog/feestje.png"
                                    alt="Feestje"
                                    className="xs:w-full sm:w-full md:w-full lg:w-full h-full object-cover"
                                />
                            </picture>
                            <div
                                className="absolute inset-0 bg-gray-800 opacity-50 mix-blend-multiply"
                                aria-hidden="true"
                            />
                        </div>
                    </div>
                </div>
                <div className="xs:px-8 sm:px-8 md:px-16 lg:px-16 xs:py-12 sm:py-12 md:py-24 lg:py-24 max-w-7xl mx-auto">
                    <h1 className="block text-white font-custom italic font-bold uppercase xl:inline xs:text-5xl sm:text-5xl md:text-6xl lg:text-6xl break-words">
                        Hoe je een feestje bouwt zonder de kater: Drie
                        alcoholvrije cocktails die je smaakpapillen laten dansen
                    </h1>
                    <p className="mt-4 text-gray-100 break-words">
                        Heb je ooit op een feest gestaan met een glas water in
                        je hand, terwijl iedereen om je heen proost met de meest
                        kleurrijke en exotische drankjes? Voelde je je als een
                        smartphone met een lege batterij op een festival? Vrees
                        niet, want ik kom je redden met recepten voor{" "}
                        <a
                            href={route("blogs.nineteenth")}
                            className="text-we-are-yellow"
                        >
                            alcoholvrije cocktails
                        </a>{" "}
                        die zo lekker zijn dat zelfs je lever je een staande
                        ovatie zal geven.
                    </p>
                    {/* -- */}
                    <h2 className="text-white mt-8 font-bold uppercase xs:text-3xl sm:text-3xl break-words">
                        1. De Tropische Faux-jito: Een Mojito zonder de Oh-no
                    </h2>
                    <p className="mt-4 text-gray-100 break-words">
                        Laten we beginnen met een klassieker: de Mojito. Maar
                        dan zonder de rum, want we willen de volgende dag fris
                        en fruitig op ons werk verschijnen, nietwaar?
                    </p>
                    {/*  */}
                    <h3 className="text-white mt-8 font-bold uppercase xs:text-3xl sm:text-3xl break-words">
                        Ingrediënten
                    </h3>
                    <ul className="mt-4 text-gray-100 break-words list-disc">
                        <li>
                            Verse muntblaadjes (een handvol, alsof je geld
                            uitgeeft in een winkel die geen retourbeleid kent)
                        </li>
                        <li>
                            1 limoen (in partjes, net als je leven, in stukjes
                            verdeeld)
                        </li>
                        <li>
                            2 eetlepels rietsuiker (of naar smaak, we oordelen
                            hier niet)
                        </li>
                        <li>IJsblokjes (zoveel als je exen)</li>
                        <li>
                            Bruiswater (om het sprankelend te houden, net als je
                            persoonlijkheid)
                        </li>
                        <li>
                            Optioneel: een scheutje sodawater met een smaakje,
                            voor de waaghalzen onder ons
                        </li>
                    </ul>
                    {/* -- */}
                    <h3 className="text-white mt-8 font-bold uppercase xs:text-3xl sm:text-3xl break-words">
                        Bereiding
                    </h3>
                    <ul className="mt-4 text-gray-100 break-words list-decimal">
                        <li>
                            Neem een stevig glas en gooi je munt en
                            limoenpartjes erin.
                        </li>
                        <li>
                            Pak een muddler of de achterkant van een lepel (we
                            zijn hier niet op een bartenderschool) en plet de
                            boel tot de munt en limoen hun geheimen prijsgeven.
                        </li>
                        <li>
                            Strooi de suiker erbij alsof het confetti is op je
                            verjaardagsfeestje.
                        </li>
                        <li>
                            Vul het glas met ijsblokjes alsof je een iglo bouwt.
                        </li>
                        <li>
                            Top het af met bruiswater en roer het door alsof je
                            een toverdrankje maakt.
                        </li>
                        <li>
                            Garneer met een munttakje of een limoenschijfje,
                            voor de Instagram-waardige foto.
                        </li>
                    </ul>
                    {/*  */}
                    <h2 className="text-white mt-8 font-bold uppercase xs:text-3xl sm:text-3xl break-words">
                        2. De Virgin Sangria: Een Feest in een Kan
                    </h2>
                    <p className="mt-4 text-gray-100 break-words">
                        Nu gaan we naar Spanje, maar zonder de kater. Sangria is
                        het vloeibare equivalent van een zomerhit, maar dan
                        zonder de vervelende bijwerkingen.
                    </p>
                    {/*  */}
                    <h3 className="text-white mt-8 font-bold uppercase xs:text-3xl sm:text-3xl break-words">
                        Ingrediënten
                    </h3>
                    <ul className="mt-4 text-gray-100 break-words list-disc">
                        <li>
                            Verschillende soorten{" "}
                            <a
                                href={route("blogs.thirty-eight")}
                                className="text-we-are-yellow"
                            >
                                fruit
                            </a>{" "}
                            (in stukjes, alsof je een fruitmand aan het
                            voorbereiden bent voor een zieke vriend)
                        </li>
                        <li>
                            1 kaneelstokje, (voor een beetje pit, zoals die ene
                            tante met haar scherpe opmerkingen)
                        </li>
                        <li>
                            1 fles alcoholvrije rode wijn (ja, dat bestaat echt)
                        </li>
                        <li>
                            500 ml bruisend mineraalwater (om het feestelijk te
                            houden)
                        </li>
                        <li>
                            Optioneel: een beetje honing of agavesiroop voor de
                            zoetekauwen
                        </li>
                    </ul>
                    {/*  */}
                    <h3 className="text-white mt-8 font-bold uppercase xs:text-3xl sm:text-3xl break-words">
                        Bereiding
                    </h3>
                    <ul className="mt-4 text-gray-100 break-words list-decimal">
                        <li>
                            Snijd al het fruit in hapklare stukjes en doe ze in
                            een grote kan alsof je een fruitmand aan het
                            voorbereiden bent voor een zieke vriend.
                        </li>
                        <li>Gooi het kaneelstokje erbij voor wat magie.</li>
                        <li>
                            Schenk de alcoholvrije rode wijn eroverheen alsof je
                            een toverdrank brouwt.
                        </li>
                        <li>
                            Laat het een paar uur in de koelkast staan, zodat
                            alle smaken kunnen trouwen (en hopelijk blijven ze
                            bij elkaar).
                        </li>
                        <li>
                            Voeg vlak voor het serveren het bruiswater toe voor
                            de bubbels.
                        </li>
                        <li>
                            Serveer in glazen met veel ijs en voel je als een
                            kind dat stiekem van de volwassenen tafel drinkt.
                        </li>
                    </ul>
                    {/*  */}
                    <h2 className="text-white mt-8 font-bold uppercase xs:text-3xl sm:text-3xl break-words">
                        3. De Designated Driver's Delight: Een Appel-Gember
                        Spritz
                    </h2>
                    <p className="mt-4 text-gray-100 break-words">
                        Als laatste hebben we iets voor de helden van de avond:
                        de BOB's. Deze appel-gember spritz is zo verfrissend dat
                        je bijna blij bent dat je de auto hebt meegenomen.
                    </p>
                    {/*  */}
                    <h3 className="text-white mt-8 font-bold uppercase xs:text-3xl sm:text-3xl break-words">
                        Ingrediënten
                    </h3>
                    <ul className="mt-4 text-gray-100 break-words list-disc">
                        <li>
                            Appelsap (het liefst versgeperst, voor de illusie
                            van gezondheid)
                        </li>
                        <li>
                            Gemberbier (niet te verwarren met gemberale, dat is
                            voor amateurs)
                        </li>
                        <li>
                            Limoensap (voor de zure touch, zoals je gezicht als
                            je de rekening krijgt)
                        </li>
                        <li>IJsblokjes (wederom, bouw die iglo)</li>
                        <li>
                            Verse gember (geschild en in dunne plakjes, alsof je
                            een kunstenaar bent)
                        </li>
                    </ul>
                    {/*  */}
                    <h3 className="text-white mt-8 font-bold uppercase xs:text-3xl sm:text-3xl break-words">
                        Bereiding
                    </h3>
                    <ul className="mt-4 text-gray-100 break-words list-decimal">
                        <li>
                            Vul een glas met ijsblokjes alsof je een sneeuwpop
                            aan het maken bent.
                        </li>
                        <li>
                            Schenk het appelsap erbij, ongeveer tot de helft van
                            het glas.
                        </li>
                        <li>
                            Voeg een scheutje limoensap toe voor wat extra
                            flair.
                        </li>
                        <li>
                            Top het af met gemberbier en roer het door alsof je
                            de loterij hebt gewonnen.
                        </li>
                        <li>
                            Garneer met een paar plakjes verse gember en een
                            limoenpartje voor de esthetiek.
                        </li>
                    </ul>
                    <p className="mt-4 text-gray-100 break-words">
                        En daar heb je het, drie alcoholvrije cocktails die je
                        feest naar een hoger niveau tillen zonder dat je de
                        volgende dag met een kater wakker wordt. Dus, hef het
                        glas (met iets anders dan water) en geniet van de
                        smaakexplosies. Proost op een avond die je je
                        daadwerkelijk zult herinneren!
                    </p>
                </div>
                <Contact />
            </div>
        </Blog>
    );
};
